const ConvertURLToFile = async (url, fileName, mimeType) => {
  const response = await fetch(url);
  const data = await response.blob();
  return new File([data], fileName, { type: mimeType });
};

export default ConvertURLToFile;
